import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useBarometerCarSold() {
  const { startListen } = useWebSocketStore()
  const { updateBarometerCarData } = useUpdateCar()

  const carSold = () => {
    startListen({
      eventName: 'premium.CAR_SOLD',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        updateBarometerCarData('unknown', event.context.carId, (data) => {
          return {
            ...data,
            state: 'SOLD',
          }
        })
      },
    })
  }

  return { carSold }
}
